import { render, staticRenderFns } from "./Signin.vue?vue&type=template&id=87d88528&"
import script from "./Signin.vue?vue&type=script&lang=js&"
export * from "./Signin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87d88528')) {
      api.createRecord('87d88528', component.options)
    } else {
      api.reload('87d88528', component.options)
    }
    module.hot.accept("./Signin.vue?vue&type=template&id=87d88528&", function () {
      api.rerender('87d88528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/oicd/Signin.vue"
export default component.exports